module.exports = __webpack_public_path__ + "static/media/img-groc-background.3200c5f9.png";